import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose, withStateHandlers } from 'recompose'
import { toggleResolvedThreads } from '../../../store/actions/discuss'
import { currentBlockIdSelector, hasMouseSelector } from '../../../store/selectors/selectors'
import {
  blockThreadsSelector,
  boardThreadsSelector,
  showResolvedThreadsSelector,
  newThreadSelector
} from '../../../store/selectors/discussSelectors'
import { smallScreenSelector } from '../../../store/selectors/boardSelectors'

const DiscussBarContianer = compose(
  connect(
    state => {
      const smallScreen = smallScreenSelector(state)
      if (smallScreen)
        return {
          smallScreen: true,
          touchPlacing: !hasMouseSelector(state) && newThreadSelector(state),
          showResolved: showResolvedThreadsSelector(state)
        }

      const currentBlock = currentBlockIdSelector(state)
      const props = {
        showResolved: showResolvedThreadsSelector(state),
        threads: currentBlock
          ? blockThreadsSelector(state)
          : boardThreadsSelector(state)
      }
      return props
    },
    {
      toggleResolvedThreads: () => toggleResolvedThreads()
    }
  ),
  withStateHandlers(
    { previewThread: null },
    {
      mouseEnter: () => number => ({ previewThread: number }),
      mouseLeave: () => () => ({ previewThread: null })
    }
  ),
  withTranslation()
)

export default DiscussBarContianer
